import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ShowHideSubTable } from "../../components/ShowHideSubTable";
import {
  getCustomSubcategory,
  createSubcategory,
  updateSubcategory,
  deleteSubcategory,
  getSystemBoundarySubcategory,
} from "../../../../../apis/Business/InventoryApi";
import SubcategoryBox from "../../components/SubcategoryBox";
import { useInvalidateQuery } from "../../../../../components/InvalidateQueryContext";
import InventoryCustomTable from "./Table";
import inventoryCustomIcon from "../../../../../assets/design-revamp-company/category-icons/inventory_custom_icon.svg";
const InventoryCustom = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState();
  const [customSubcategories, setCustomSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [systemBoundaryCustom, setSystemBoundaryCustom] = useState({});
  const { invalidateKey, resetKey } = useInvalidateQuery();
  const key = "add-new-inventory-subcategory";
  const deleteKey = "delete-inventory-subcategory";

  const [loadedSubcategories, setLoadedSubcategories] = useState({});

  useEffect(() => {
    customSubcategories.forEach((sub) => {
      if (!loadedSubcategories[sub.id]) {
        getSystemBoundarySubcategory({
          businessId,
          setSystemBoundarySubCategory: (data) => {
            setSystemBoundaryCustom((prev) => ({ ...prev, [sub.id]: data }));
          },
          subcategory: sub.name,
        });
        setLoadedSubcategories((prev) => ({ ...prev, [sub.id]: true }));
      }
    });
  }, [customSubcategories, businessId, loadedSubcategories]);

  useEffect(() => {
    getCustomSubcategory({
      businessId: businessId,
      setCustomSubcategory: setCustomSubcategories,
    });
  }, [businessId]);

  const handleSaveSubcategory = (subcategoryData) => {
    if (subcategoryData.objectId) {
      updateSubcategory(subcategoryData)
        .then(() => {
          setCustomSubcategories((prevSubcategories) =>
            prevSubcategories.map((sub) =>
              sub.id === subcategoryData.objectId ? subcategoryData : sub
            )
          );
        })
        .catch((err) => console.error(err));
    } else {
      createSubcategory(subcategoryData)
        .then((newSubcategory) => {
          setCustomSubcategories((prevSubcategories) => [
            ...prevSubcategories,
            newSubcategory,
          ]);
        })
        .catch((err) => console.error(err));
    }
  };

  const handleInvalidateAndReset = useCallback(
    (setSubcategoryCustom, setSubcategoryDescCustom, isNewSubcategory) => {
      if (invalidateKey === key || invalidateKey === deleteKey) {
        getCustomSubcategory({
          businessId: businessId,
          setCustomSubcategory: setCustomSubcategories,
        });
        if (isNewSubcategory) {
          setSubcategoryCustom("");
          setSubcategoryDescCustom("");
        }
      }
      resetKey();
    },
    [businessId, resetKey, invalidateKey, key, deleteKey]
  );

  useEffect(() => {
    handleInvalidateAndReset(
      () => {},
      () => {}
    );
  }, [invalidateKey, businessId, handleInvalidateAndReset]);

  const handleDeleteSubcategory = (subcategoryData) => {
    deleteSubcategory(subcategoryData)
      .then(() => {
        setCustomSubcategories((prevSubcategories) =>
          prevSubcategories.filter((sub) => sub.id !== subcategoryData.objectId)
        );
      })
      .catch((err) => console.error(err));
  };

  const handleEditSubcategory = (subcategory) => {
    setSelectedSubcategory(subcategory);
  };
  return (
    <div className="component-energy-contents">
      <div style={{ marginTop: "12px" }}>
        <SubcategoryBox
          businessId={businessId}
          createSubcategoryApi={handleSaveSubcategory}
          handleInvalidateAndReset={handleInvalidateAndReset}
          isNewSubcategory={true}
          icon={inventoryCustomIcon}
          showIcon={true}
        />
        {Array.isArray(customSubcategories) &&
          customSubcategories.length > 0 &&
          customSubcategories.map((sub, index) => {
            return (
              <div style={{ position: "relative" }}>
                <SubcategoryBox
                  key={sub.id}
                  subcategory={sub.name}
                  subcategoryDesc={sub.description}
                  subcategoryId={sub.id}
                  businessId={businessId}
                  createSubcategoryApi={createSubcategory}
                  deleteSubcategoryApi={handleDeleteSubcategory}
                  updateSubcategoryApi={handleSaveSubcategory}
                  onEdit={handleEditSubcategory}
                  isLetter={false}
                  isNormal={false}
                  baseSequence={"5.1."}
                  index={index}
                  baseNumber={7}
                  handleInvalidateAndReset={handleInvalidateAndReset}
                  icon={inventoryCustomIcon}
                  showIcon={true}
                  showSystemBoundary={true}
                  systemBoundaryProps={{
                    businessId: businessId,
                    systemBoundary: systemBoundaryCustom?.[sub.id] ?? "",
                    setSystemBoundary: (value) =>
                      setSystemBoundaryCustom((prev) => ({
                        ...(prev || {}),
                        [sub.id]: value,
                      })),
                    totalObjCategory: sub.name,
                    customStyles: { marginTop: "10px", marginLeft: "40px" },
                    isInventory: true,
                  }}
                />

                {showTable === sub.id && (
                  <InventoryCustomTable
                    businessId={businessId}
                    subcategory={sub.name}
                    subcategory_description={sub.description}
                    subcategoryId={sub.id}
                  />
                )}
                <ShowHideSubTable
                  showTable={showTable}
                  setShowTable={setShowTable}
                  subId={sub.id}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default InventoryCustom;
